/** Load average color thresholds (per issue: normalized against 1.0 per CPU). */

export function getLoadColor(load, cpuCount = 1) {
  const value = Number(load);
  if (!Number.isFinite(value)) return '#8c8c8c';
  const normalized = cpuCount > 0 ? value / cpuCount : value;
  if (normalized < 0.7) return '#52c41a';
  if (normalized <= 1.0) return '#faad14';
  return '#ff4d4f';
}

export function formatLoad(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : '-';
}

export function parseLoadFromResources(resources) {
  if (!resources || resources.system?.platform === 'win32') {
    return null;
  }
  const sys = resources.system || {};
  const cpuCount = resources.cpu?.count || 1;
  const m1 = sys.loadavg_1m ?? sys.loadavg?.[0];
  const m5 = sys.loadavg_5m ?? sys.loadavg?.[1];
  const m15 = sys.loadavg_15m ?? sys.loadavg?.[2];
  if (m1 == null && m5 == null && m15 == null) {
    return null;
  }
  return {
    m1,
    m5,
    m15,
    cpuCount,
    color1: getLoadColor(m1, cpuCount),
    color5: getLoadColor(m5, cpuCount),
    color15: getLoadColor(m15, cpuCount),
  };
}
